/**
 * Phase 1 FE event names for `@mivo/app` (events.md source=fe, app=app).
 * Payload string literals stay snake_case (spec §3.10 exception).
 */
export const APP_FRONTEND_EVENT_NAMES = [
  "signup_started",
  "auth_logout",
  "subscription_checkout_started",
  "session_audio_upload_started",
  "practice_finance_summary_viewed",
] as const;

export type AppFrontendEventName = (typeof APP_FRONTEND_EVENT_NAMES)[number];

export const APP_FRONTEND_EVENT_NAME_SET: ReadonlySet<string> = new Set(APP_FRONTEND_EVENT_NAMES);

/** Clinical resource ids forbidden by default (BR-14). */
export const FORBIDDEN_CLINICAL_PROP_KEYS = ["patient_id", "session_id", "appointment_id"] as const;
